export const TEXAS_HOLDEM_LOBBY_ROUTE = '/games/texas-holdem';
export const TEXAS_HOLDEM_ROOM_ROUTE = `${TEXAS_HOLDEM_LOBBY_ROUTE}/rooms/:roomCode`;
export const TEXAS_HOLDEM_SETTLEMENT_ROUTE = `${TEXAS_HOLDEM_ROOM_ROUTE}/settlement`;

export const GOMOKU_LOBBY_ROUTE = '/games/gomoku';
export const GOMOKU_ROOM_ROUTE = `${GOMOKU_LOBBY_ROUTE}/rooms/:roomCode`;

export function normalizeRoomCodeForRoute(roomCode = '') {
  const rawRoomCode = String(roomCode || '').trim();

  if (!rawRoomCode) {
    return '';
  }

  try {
    return encodeURIComponent(decodeURIComponent(rawRoomCode).trim().toUpperCase());
  } catch (error) {
    return encodeURIComponent(rawRoomCode.toUpperCase());
  }
}

export function buildTexasHoldemLobbyRoute() {
  return TEXAS_HOLDEM_LOBBY_ROUTE;
}

export function buildTexasHoldemRoomRoute(roomCode = '') {
  return `${TEXAS_HOLDEM_LOBBY_ROUTE}/rooms/${normalizeRoomCodeForRoute(roomCode)}`;
}

export function buildTexasHoldemSettlementRoute(roomCode = '') {
  return `${buildTexasHoldemRoomRoute(roomCode)}/settlement`;
}

export function buildGomokuLobbyRoute() {
  return GOMOKU_LOBBY_ROUTE;
}

export function buildGomokuRoomRoute(roomCode = '') {
  return `${GOMOKU_LOBBY_ROUTE}/rooms/${normalizeRoomCodeForRoute(roomCode)}`;
}
